import React from 'react';
import PropTypes from 'prop-types';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {headerItemsLabels} from '../../../Common/Header/header';
import {PL_DialogWrapper}  from 'infrastructure/js/components/Dialog/dialog';
import CreateVisibleDeviceDialog from './Dialogs/CreateVisibleDeviceDialog/createVisibleDeviceDialog.js';
import VisibilityDevicesViewGrid from './VisibilityDevicesViewGrid/visibilityDevicesViewGrid';
import {RfidSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import MessageDialog from 'infrastructure/js/components/Dialog/MessageDialog/messageDialog';
import {reduxForm} from 'redux-form';
import RfidHeader from '../Common/rfidHeader';
class VisibilityDevicesView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.labels = createLabelHelper('mat.administration.rfidsettings.visibilityDevice.view.');
    this.dialogLabels = createLabelHelper('mat.dialog.');
  }

  componentDidMount() {
    this.props.actions.rfidSettingsPageActions.onSelectedMenuItemChanged(RfidSettingsMenuItemsIds.NAV_ELEMENT_VISIBILITY_DEVICE);
    this.props.actions.init(false);
  }

  handleRemoveVisibilityDevice = () => {
    if(!this.props.sSelectedRowsData || !this.props.sSelectedRowsData.size){
      return;
    }
    let selectedDevicesIds = this.props.sSelectedRowsData.map((item) => {
      return item.id;
    });

    let deviceAppProfileId = this.props.sSelectedRowsData.get(0).deviceAppProfileId;
    let data = {
      selectedDevicesIds : selectedDevicesIds,
      deviceAppProfileId : deviceAppProfileId
    };
    this.props.actions.onRemoveVisibleDevicesClick(this.getMessageDialogBuilder(), data);
  };

  getMessageDialogBuilder = () => {
    return (fnCloseDialog, callback) => {
      let title = this.labels.get('operation.removeDevice.confirmation.title');
      let type = 'warning';
      let message = this.labels.get('operation.removeDevice.confirmation.message');
      let children =  [<MessageDialog.DataRow key={`confirmMessageDataRow`} label={message} value={''}/>];
      let buttons = [
        {id:'cancel',text: this.dialogLabels.get('cancel'), action: fnCloseDialog, bsStyle: 'default'},
        {id:'remove',text: this.labels.get('operation.removeDevice.confirmation.button.remove'), action: callback , bsStyle: 'primary'}
      ];
      let className = 'confirm-message';
      let messageDialogDescriptor = {title, buttons, children,  className, type};
      return messageDialogDescriptor;
    };
  };

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;
    return {
      dropdown: {
        id : 'deviceAppDropDown',
        name : 'deviceAppDropDown',
        options: this.props.sData.get('deviceAppsOptions'),
        disabled: this.props.sData.get('deviceAppsOptions').length <= 1,
        changeCallback: this.props.actions.onDeviceAppChanged,
      },
      buttons: [
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onCreateVisibilityDeviceClick,
          disabled: this.props.sData.get('deviceAppsOptions').length === 0
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onEditVisibilityDeviceClick,
          actionData: selectedRowsData.get(0)
        },
        {
          id:'remove',
          label: headerItemsLabels.REMOVE,
          icon: 'pl pl-delete-icon',
          disabled: !(hasRows && selectedRowsData.size >= 1),
          action: this.handleRemoveVisibilityDevice
        },
      ],
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  renderGrid = () => {
    if(!this.props.sData.get('selectedDeviceApp')) {
      return null;
    }
    return <VisibilityDevicesViewGrid actions={this.props.actions.visibilityDevicesViewGridActions} />
  };

  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <RfidHeader {...headerItems} change = {this.props.change} selectedDeviceApp={this.props.sData.get('selectedDeviceApp')}/>
        {this.renderGrid()}

        <PL_DialogWrapper dialogComponent={CreateVisibleDeviceDialog}
                          show={this.props.sCreateVisibleDeviceDialogData.get('show')}
                          actions={this.props.actions.createVisibleDeviceDialogActions}
                          sData={this.props.sCreateVisibleDeviceDialogData}
                          deviceApp={this.props.sData.get('selectedDeviceApp')}
                          reloadParentComponent={this.reloadPage}
        />

      </div>
    );
  }
}

export default reduxForm({
    form: 'VisibilityDevicesForm'
  }
)(VisibilityDevicesView);

VisibilityDevicesView.propTypes = {
  sGrid: PropTypes.object,
};
